// Angular
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IDateFieldSpecs } from '../interfaces/field-specs';
import { DateInputComponent} from './date-input.component';
import { EDateInputAdditionalClass } from "./date-additional-class.enum";
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';


@Component({
    selector: 'date-field',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [attr.class]="fieldConfig.className"
                    [options]="fieldConfig"
                    [isInternalError]="isInternalError"
                    [isFull]="isFull">
            <date-input #input
                        [fieldConfig]="fieldConfig"
                        [additionnalClass]="additionnalClass"
                        [yearNavigator]="yearNavigator"
                        [monthNavigator]="monthNavigator"
                        [alignRightDatePicker]="alignRightDatePicker"
                        [onlyOneMonth]="onlyOneMonth"
                        [isFull]="isFull"
                        [isDateReturnedOnBlur]="isDateReturnedOnBlur"
                        [iconCalendar]="iconCalendar"
                        [isPositionFixed]="isPositionFixed"
                        [baseZIndex]="baseZIndex"
                        (onBlur)="onBlur.emit($event)"
                        (onFocus)="onFocus.emit($event)"
                        (onSelect)="onSelect.emit($event)"
                        (selectDate)="selectDate.emit($event)"></date-input>
        </form-field>
    `,
})

export class DateComponent {

    @Input()
    public fieldConfig: IDateFieldSpecs;
    @Input()
    public yearNavigator: boolean;
    @Input()
    public monthNavigator: boolean;
    @Input()
    public alignRightDatePicker: boolean = false;
    @Input()
    public onlyOneMonth: boolean;
    @Input()
    public isFull: boolean = false;
    @Input()
    public isPositionFixed: boolean = false;
    @Input()
    public additionnalClass: EDateInputAdditionalClass;
    @Input()
    public baseZIndex: number = 1;
    @Input()
    public iconCalendar: IconDefinition = faCalendar;
    @Input()
    public isInternalError: boolean = false;
    @Input()
    public isDateReturnedOnBlur: boolean = false;


    @Output()
    public readonly onBlur: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();

    @Output()
    public readonly selectDate: EventEmitter<string> = new EventEmitter();

    @Output()
    public readonly onFocus: EventEmitter<boolean> = new EventEmitter();

    @ViewChild('input')
    public input: DateInputComponent;

    public asyncToggle(): void {
        this.input.asyncToggle();
    }
}
